// removed by extract-text-webpack-plugin
module.exports = {"header":"header___3gqz7","logo":"logo___3aXyn","content":"content___32LGH","content-large":"content-large___1y2wb","close-button":"close-button___kFIY1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Shared/ModalHeader.scss
// module id = imzI
// module chunks = 46